export default __webpack_public_path__ + "static/media/servo.da588d65.svg";